import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { PhoneNumber } from "../../phone";
import { phoneNumberZodSchema } from "../../phone";

type SetUserPhoneNumberInitCommand = {
    readonly _id: string;
    readonly _type: "SET_USER_PHONE_NUMBER_INIT_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly phoneNumber: PhoneNumber;
};

type FactoryParams = Except<
    SetUserPhoneNumberInitCommand,
    "_id" | "_type" | "_createdAt"
>;
const setUserPhoneNumberInitCommandFactory = (
    params: FactoryParams,
): SetUserPhoneNumberInitCommand => {
    const command: SetUserPhoneNumberInitCommand = {
        ...params,
        _id: generateId({ prefix: "set_user_phone_number_init_command__" }),
        _type: "SET_USER_PHONE_NUMBER_INIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const setUserPhoneNumberInitZodSchema: z.ZodSchema<SetUserPhoneNumberInitCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("SET_USER_PHONE_NUMBER_INIT_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        phoneNumber: phoneNumberZodSchema,
    });

export {
    setUserPhoneNumberInitCommandFactory,
    setUserPhoneNumberInitZodSchema,
};
export type {
    SetUserPhoneNumberInitCommand,
    FactoryParams as SetUserPhoneNumberInitCommandFactoryParams,
};
